import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { cleanState } from '@ublend-npm/aula-editor';
import { MATERIALS_PERMISSION_DENIED } from '@core/constants/analytics';
import { analyticsTrackEvent } from '@core/utils/analytics';
import MaterialListEducatorOnly from './MaterialListEducatorOnly';
import * as appCreators from '../../../../../actions/materials';
import { selectors, operations } from '../../../../../store/materials';
import {
  currentClassRoomId,
  getIsStudent,
} from '../../../../../../core/selectors/classroom';
import {
  canAccessEducatorArea,
  createPermissionDeniedToast,
  isMaterialRbacEnabled,
} from '../../../../../../core/materials/permissions';
import { getUserPermissionsInCurrentSpace } from '../../../../../../core/utils/permissions';
import showToast from '../../../../../../core/toasts/operations/showToast.operation';

const selectPieces = createStructuredSelector({
  classRoomId: currentClassRoomId,
  materialEducatorOnlyIds: selectors.topLevelMaterialEducatorOnlyIds,
  isFetchingSections: selectors.isFetchingSections,
  canCreate: canAccessEducatorArea,
  canView: canAccessEducatorArea,
  permissions: getUserPermissionsInCurrentSpace,
  isRbacEnabled: isMaterialRbacEnabled,
});

const mapStateToProps = (state) => {
  const {
    classRoomId,
    materialEducatorOnlyIds,
    isFetchingSections,
    canCreate,
    canView,
    permissions,
    isRbacEnabled,
  } = selectPieces(state);

  return {
    classRoomId,
    isFetchingSections,
    materialEducatorOnlyIds,
    canCreate,
    canView,
    permissions,
    isRbacEnabled,
    isStudent: getIsStudent(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onAddClick: () =>
    dispatch(
      operations.createSection({
        content: cleanState,
        educatorOnly: true,
        hidden: false,
        onSelect: appCreators.selectSectionInJourney,
      })
    ),
  onPermissionDenied: (permissionKey, spaceId) => {
    analyticsTrackEvent(MATERIALS_PERMISSION_DENIED, {
      permissionKey,
      spaceId,
    });
    dispatch(showToast(createPermissionDeniedToast(permissionKey)));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaterialListEducatorOnly);
